import {
  ifElse,
  isEmpty,
  isNil,
  pipe,
  reject,
} from 'ramda';
import { createSelector } from 'reselect';

import { RootState } from '../types';
import { isChatMutedSelector } from './chat';
import { backgroundMusicSoundSelector, gameSoundsSelector, videoStreamSoundSelector } from './media';

export * from './bet';
export * from './config';
export * from './dialog';
export * from './game';
export * from './gameTypes';
export * from './locale';
export * from './media';
export * from './menu';
export * from './notification';
export * from './oss';
export * from './round';
export * from './table';
export * from './tips';
export * from './ui';
export * from './user';
export * from './video';
export * from './winnerList';

export { lobbySelector } from './lobby';

export const isAuthenticatedSelector = (state: RootState) => state.isAuthenticated;

export const settingsSelector = createSelector(
  gameSoundsSelector,
  isChatMutedSelector,
  backgroundMusicSoundSelector,
  videoStreamSoundSelector,
  pipe((gameSounds, hideOthersChat, backgroundMusic, videoStreamSound) => ({
    gameSounds,
    hideOthersChat,
    backgroundMusic,
    videoStreamSound,
  }), reject(isNil), ifElse(isEmpty, () => undefined, (obj) => obj))
);
